import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import React from "react";
import { ImpersonateUserForm } from "./ImpersonateUserForm";

export const ImpersonateDialog: React.FC<{
	open: boolean;
	onClose: () => void;
}> = ({ open, onClose }) => {
	return (
		<Dialog
			open={open}
			onClose={onClose}
			maxWidth="sm"
			fullWidth
			data-component="impersonate-dialog"
		>
			<DialogTitle data-component="impersonate-title">
				Impersonate User
			</DialogTitle>
			<DialogContent data-component="impersonate-content">
				<ImpersonateUserForm onClose={onClose} />
			</DialogContent>
		</Dialog>
	);
};
